module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/it-9938f4b9588502f93b20243ed3a5b60c.svg";